
  import React from "react"
  import Component from "D:/Projects/Gatsby/simple-adrianmanduc.com/src/layouts/index.js"
  import data from "D:\\Projects\\Gatsby\\simple-adrianmanduc.com\\.cache\\json\\layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js